import { EntrepriseTLR } from "../../entreprises/entities/entreprise-tlr.entity";
import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";

export class IntervenantPaInfo {
    entreprisePa!: boolean;
	paInfos!: PaInfo[];
}

export class PaInfo {
    numero!: string;
	dateFin: LocalDate | null = null;
}